import { render, staticRenderFns } from "./ExpohallarielBirdView.vue?vue&type=template&id=16fffb7a&scoped=true&"
import script from "./ExpohallarielBirdView.vue?vue&type=script&lang=js&"
export * from "./ExpohallarielBirdView.vue?vue&type=script&lang=js&"
import style0 from "./ExpohallarielBirdView.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./ExpohallarielBirdView.vue?vue&type=style&index=1&id=16fffb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fffb7a",
  null
  
)

export default component.exports